import { z } from "zod";

/** Saved results only. No body, HTML, files or customer contact details enter a turn's receipts. */
const identity = { id: z.string().min(1).max(160), targetId: z.string().min(1).max(160), name: z.string().max(160) };
export const TurnChangeSchema = z.discriminatedUnion("area", [
  z.object({ ...identity, area: z.literal("website"), outcome: z.enum(["design", "content", "photos"]) }).strict(),
  z.object({ ...identity, area: z.literal("blog"), outcome: z.enum(["saved", "live", "scheduled", "unpublished", "deleted"]),
    status: z.enum(["draft", "published", "scheduled"]), at: z.string().datetime({ offset: true }).optional(), timeZone: z.string().max(80).optional(),
  }).strict(),
  z.object({ ...identity, area: z.literal("shop"), entity: z.enum(["product", "category", "stock", "order"]),
    outcome: z.enum(["created", "saved", "available", "hidden", "deleted", "stock", "order"]), result: z.string().max(300).optional(), refundOutcome: z.enum(["stripe", "manual", "pending", "failed", "items"]).optional(), visibility: z.enum(["live", "hidden"]),
  }).strict(),
]);
export type TurnChange = z.infer<typeof TurnChangeSchema>;
export type RefundOutcome = NonNullable<Extract<TurnChange, { area: "shop" }>["refundOutcome"]>;
export const TurnChangesSchema = z.array(TurnChangeSchema).max(16);

/** Stable operation ids make checkpoint retries and later action settlement add a result once. */
export function appendTurnChange<T extends { changes?: TurnChange[] }>(record: T, change: TurnChange): T {
  const bounded = TurnChangeSchema.parse({ ...change, id: change.id.slice(0, 160), targetId: change.targetId.slice(0, 160), name: change.name.slice(0, 160) });
  if (record.changes?.some(item => item.id === bounded.id)) return record;
  return { ...record, changes: [...(record.changes ?? []), bounded].slice(-16) };
}
